import {
  faCircleExclamation,
  faWarning,
} from '@fortawesome/pro-solid-svg-icons';
import { ModalFuncProps } from 'antd/es/modal';
import merge from 'lodash/merge';
import { defaultModalProps, Modal } from './modal';
import * as styles from './modal.module.css';
import { FontAwesomeIcon } from '../icon/icon';

const defaultMethodProps: ModalFuncProps = {
  className: styles.modal_method,
  icon: <FontAwesomeIcon icon={faWarning} size={24} />,
  zIndex: Number(styles.zIndex),
};

const defaultErrorModalProps: ModalFuncProps = {
  className: styles.modal_method,
  icon: <FontAwesomeIcon icon={faCircleExclamation} size={24} />,
  zIndex: Number(styles.zIndex),
};

export const confirm = (props: ModalFuncProps = {}) => {
  const modalProps: ModalFuncProps = {
    ...props,
    okText: (
      <span data-cy={`modal.confirm.${props.okText || 'Ok'}`}>
        {props.okText || 'Ok'}
      </span>
    ),
    cancelText: (
      <span data-cy={`modal.cancel.${props.cancelText || 'Cancel'}`}>
        {props.cancelText || 'Cancel'}
      </span>
    ),
  };

  return Modal.confirm(
    merge({}, defaultModalProps, defaultMethodProps, modalProps),
  );
};

export const confirmWithCenteredStyles = (props: ModalFuncProps = {}) => {
  const modalProps: ModalFuncProps = {
    width: 320,
    icon: <FontAwesomeIcon icon={faWarning} size={40} />,
    centered: true,
    ...props,
    className: `${styles.modal_method} ${styles.modal_method_centered} ${props.className}`,
  };

  return Modal.confirm(
    merge({}, defaultModalProps, defaultMethodProps, modalProps),
  );
};

export const error = (props: ModalFuncProps = {}) =>
  Modal.error(merge({}, defaultModalProps, defaultErrorModalProps, props));
